import React from 'react'
import Block from '../../adapters/helpers/Block'
export default function ArticleWrapper(props) {
    const articleDataWrapperLength = props?.document?.fields?.aricleDataWrapper?.length;
    return (
        <div className='article-main-wrap'>
            <div>
                {props?.document?.fields?.aricleDataWrapper
                    .filter((val, index) => index == 0)
                    .map((res) => {
                        return new Block(res).renderBlockFromDocument({
                            extraAttributes: props.extraAttributes,
                        })
                    })}
            </div>

            <div className='lower-article-body'>
                <div className='leftbigSection'>
                    {props?.document?.fields?.aricleDataWrapper
                        .filter((val, index) => val.fields.contentType !== 'additionalReadingBlock' && val.fields.contentType !== 'productRecommenderBlock' && index != 0 && index !== articleDataWrapperLength - 1)
                        .map((res) => {
                            return new Block(res).renderBlockFromDocument({
                                extraAttributes: props.extraAttributes,
                            })
                        })}
                </div>
                <div className='rightsmallsection'>
                    {props?.document?.fields?.aricleDataWrapper
                        .filter((val, index) =>  val.fields.contentType === ('additionalReadingBlock' || 'productRecommenderBlock') || index == (articleDataWrapperLength - 1|| articleDataWrapperLength - 2))
                        .map((res) => {
                            return new Block(res).renderBlockFromDocument({
                                extraAttributes: props.extraAttributes,
                            })
                        })}
                        {props?.document?.fields?.aricleDataWrapper
                        .filter((val, index) =>  val.fields.contentType === 'productRecommenderBlock' || index == articleDataWrapperLength - 2)
                        .map((res) => {
                            return new Block(res).renderBlockFromDocument({
                                extraAttributes: props.extraAttributes,
                                onClickCallback: props.onClickCallback
                                
                            })
                        })}
                </div>
            </div>
        </div>
    )
}
